import React from "react";
import Header from "../components/Header";
import Video from "../components/Video";
import StaticHome from "../components/StaticHome";
import Carousel from "../components/Carousel";
import image1 from "../assets/img/02.png";
import image2 from "../assets/img/2348y67.png";
import ContactForm from "../components/ContactForm";
import SwiperComponent from "../components/Swiper";
import { Link } from "react-router-dom";

function Home() {
  return (
    <>
      <Video />

      <container>
        <section className="bsection-two">
          <div className="container">
            <div className="text-center bsection-two-txt">
              <h1>
                <span>Hello, We’re Hob Studio.</span>
              </h1>
              <p className="bsection-two-txt-p">
                HoB Studio is a full-service creative content studio where art,
                technology, and storytelling converge. We craft high-end visuals
                that captivate, engage, and inspire. From commercials to branded
                content, we push creative and technical boundaries to deliver
                world-class visuals — because every project is a new opportunity
                to elevate the
              </p>
            </div>
          </div>

          <div className="section-two-rows">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="row-image-section-two">
                    <img src={image1} alt="Section Image 1" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className="row-txt-section-two"
                    style={{ marginLeft: "5vw" }}
                  >
                    <h4>Video Content Creation</h4>
                    <p>
                      Most content fails because it’s rushed, unpolished, and
                      poorly executed. At HoB Studio, we specialize in
                      high-quality creative and post-production services that
                      help businesses and creators produce content with purpose.
                      We ensure cohesive visuals that include motion design,
                      animation, graphics, and advanced color grading. Our
                      streamlined process simplifies production, shortens
                      timelines, and maintains brand consistency across every
                      platform. Stop guessing. Start creating with HoB Studio
                    </p>
                    <Link to="/work">See More</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="section-two-rows">
            <div className="container">
              <div className="row">
                <div className="col-md-6 order-2 order-md-1">
                  <div
                    className="row-txt-section-two"
                    style={{ marginRight: "5vw" }}
                  >
                    <h4>Latest project</h4>
                    <p>
                      From natural tones to cinematic contrast, we enhanced
                      every frame to match the vibe of this modern alpine
                      escape. Cozy, clean, and captivating just like the lodge
                      itself.
                    </p>
                    <Link to="/work">See More</Link>
                  </div>
                </div>
                <div className="col-md-6 order-1 order-md-2">
                  <div className="row-image-section-two">
                    <img src={image2} alt="Section Image 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <SwiperComponent />
        <StaticHome />
        <Carousel />
        <ContactForm />
      </container>
    </>
  );
}

export default Home;
